export enum RtbObjective {
  AWARENESS = 'AWARENESS',
  TRAFFIC = 'TRAFFIC'
}
